import React from 'react';
import { Avatar, makeStyles, Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';

import { aspectCategoriesStatusMapper } from 'src/utils/aspectCategoriesUtils';


const widthMapper = {
  small: '24px',
  normal: '32px',
  big: '40px',
};

const fontSizeMapper = {
  small: '0.75em',
  normal: '1em',
  big: '1.25em',
};

const useStyles = makeStyles(() => ({
  avatar: {
    width: ({ size }) => widthMapper[size] || '32px',
    height: ({ size }) => widthMapper[size] || '32px',
    fontSize: ({ size }) => fontSizeMapper[size] || '1em',
    fontWeight: '500',
    border: '1px solid',
  },
}));

const AspectCategoryStatusIcon = ({ category, size = 'normal', useDefaultColors = false }) => {
  const classes = useStyles({ size });

  if (!category) {
    return <>-</>;
  }

  const backgroundColor = useDefaultColors ? 'rgba(223, 225, 230, 1)'
    : aspectCategoriesStatusMapper[category]?.backgroundColor || 'rgba(223, 225, 230, 1)';
  const color = useDefaultColors ? 'rgba(100, 100, 100, 0.5)' : aspectCategoriesStatusMapper[category]?.textColor || 'rgba(74, 82, 87, 1)';
  const borderColor = useDefaultColors ? 'rgba(100, 100, 100, 0.5)'
    : aspectCategoriesStatusMapper[category]?.borderColor || 'rgba(74, 82, 87, 1)';

  return (
    <Avatar className={classes.avatar} style={{ backgroundColor, color, borderColor }}>
      <Tooltip title={`Nivel de preocupación: ${aspectCategoriesStatusMapper[category].text}`}>
        <span>
          {category}
        </span>
      </Tooltip>
    </Avatar>
  );
};

AspectCategoryStatusIcon.propTypes = {
  category: PropTypes.string,
  size: PropTypes.oneOf([ 'small', 'normal', 'big' ]),
  useDefaultColors: PropTypes.bool,
};


export {
  AspectCategoryStatusIcon,
};
